import { APIKeysCard } from "@phoenix/pages/settings/APIKeysCard";

export function SettingsAPIKeysPage() {
  return <APIKeysCard />;
}
